const initYoutube = () => {
    document.querySelectorAll('.tab-content [data-youtube-video]').forEach((el) => {
        el.insertAdjacentHTML('afterbegin', `
            <div class="ratio ratio-16x9 mb-4">
                <iframe class="rounded" src="https://www.youtube.com/embed/${el.id}" allowfullscreen></iframe>
            </div>
        `)
    })
}
initYoutube()

const initVimeo = () => {
    document.querySelectorAll('.tab-content [data-vimeo-video]').forEach((el) => {
        el.insertAdjacentHTML('afterbegin', `
            <div class="ratio ratio-16x9 mb-4">
                <iframe class="rounded" src="https://player.vimeo.com/video/${el.id}" allowfullscreen></iframe>
            </div>
        `)
    })
}
initVimeo()

const initImages = () => {
    document.querySelectorAll('.tab-content [data-image]').forEach((el) => {
        el.insertAdjacentHTML('afterbegin', `
            <img
                src="${el.getAttribute('url')}"
                class="img-fluid mb-4 rounded"
                alt=""
                width=""
                height="">
        `)
    })
}
initImages()

const initButtons = () => {
    document.querySelectorAll('.tab-content a[target="_blank"]').forEach((el) => {
        el.classList.add('btn', 'btn-primary')
        el.setAttribute('target', '')
    })
}
initButtons()

const initContent = () => {
    document.querySelectorAll('.tab-content [data-content]').forEach((el) => {
      	el.innerHTML = el.id
        el.classList.remove('d-none')
    })
}
initContent()

const initCalendar = () => {
    document.querySelectorAll('.tab-content [data-cal]').forEach((el) => {
        el.insertAdjacentHTML('afterbegin', `
            <div class="ratio ratio-1x1 mb-4">
				<iframe class="rounded" src="https://app.acuityscheduling.com/schedule.php?owner=${window.acuityOwner}&calendarID=${el.id}" allowfullscreen height="800" frameBorder="0"></iframe>
            </div>
        `)
    })
}
initCalendar()

// Listen for changes in theme editor
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.tab-content')) {
        initVideos()
        initImages()
        initButtons()
        initCalendar()
        initVimeo()
        initContent()
    }
})
var today = moment().tz("America/New_York").format('MM/DD/YYYY')
 document.querySelectorAll('.memberContent.d-none').forEach((el) => {
   var contentDate = el.getAttribute('data-date')
   if(moment(today).isSameOrAfter (contentDate)) {
     el.classList.remove('d-none')
   }
   console.log(moment(today).isSameOrAfter (contentDate))
 })
